/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { isColliding } from '../utils/collider';
import { cssParser } from '../utils/parser';

const BasketBall = ({ css, onComplete }) => {
    const [firstRender, setFirstRender] = useState(true);
    const isLevelComplete = () => {
        // return document.getElementById("purple-block")?.style?.display === "none";
        return !isColliding(document.getElementById("purple-block"), document.getElementById("purple-block-listener"))
    }
    useEffect(() => {
        if (firstRender) {
            setFirstRender(false);
        }
        else if (isLevelComplete()) {
            onComplete();
        };
    }, [css]);
    return (
        <div id="basket-ball-container">
            <img id="basket-ball" src="/images/basket-ball.png" alt="basket-ball" style={{ "animationPlayState": isLevelComplete() ? "running" : "paused" }} />
            <div id="purple-block" style={cssParser(css)}>
                <div style={{ "fontSize": "x-small" }}>#purple-block</div>
            </div>
            <div id="purple-block-listener">
            </div>
            <img id="basket-ball-pole" src="/images/basket-ball-pole.png" alt="basket-ball" />
        </div>
    )
}

export default BasketBall